import { useEffect, useState } from "react";
import { Localization } from "@viamap/viamap2-common";
import { formatPaategningFilingType } from "src/dataCollector/parseDokumentRevisionssporXml";
import { firstTingbogDokumentUuid } from "src/managers/TingbogBundlePdf";
import { loadPaategningFilings } from "src/managers/TingbogPaategningPdf";

export function ServitutPaategningNotes(props: { dokumentId?: string }) {
   const dokumentId = firstTingbogDokumentUuid(props.dokumentId);
   const [lines, setLines] = useState<string[] | null>(null);

   useEffect(() => {
      if (!dokumentId) {
         setLines(null);
         return;
      }
      let cancel = false;
      loadPaategningFilings(dokumentId).then((filings) => {
         if (cancel) {
            return;
         }
         setLines(filings.map((filing, index) => {
            const date = filing.tidspunkt.slice(0, 10);
            const typeLabel = Localization.getText(formatPaategningFilingType(filing.kind) || "Endorsement");
            return `${index}:${[date, typeLabel].filter(Boolean).join(" · ")}`;
         }));
      }).catch(() => {
         if (!cancel) {
            setLines([]);
         }
      });
      return () => {
         cancel = true;
      };
   }, [dokumentId]);

   if (!lines?.length) {
      return null;
   }
   return (
      <div className="servitut-redegoerelse__paategninger">
         {lines.map((line) => {
            const text = line.replace(/^\d+:/, "");
            return (
               <div key={line} className="servitut-redegoerelse__paategning">
                  {text}
               </div>
            );
         })}
      </div>
   );
}
